// removed by extract-text-webpack-plugin
module.exports = {"video_embed":"video_embed__3KeaW","col_1":"col_1__1o4hw","homescreen_embed":"homescreen_embed__2MkgK"};


//////////////////
// WEBPACK FOOTER
// ./components/Videoonscreen/style.css
// module id = 2wbB
// module chunks = 0